import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Typography, Container, Card, CardContent, CardMedia, Grid, Box } from '@mui/material';
import { styled } from '@mui/system';
import data from '../data.json';

// Styled components for animation and better design
const ProductImage = styled(CardMedia)({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  transition: 'transform 0.3s ease-in-out',
  '&:hover': {
    transform: 'scale(1.05)',
  },
});

const ProductContainer = styled(Card)({
  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
  transition: 'transform 0.2s',
  '&:hover': {
    transform: 'scale(1.02)',
  },
});

const ProductDetails = () => {
  const { id } = useParams();
  const [product, setProduct] = useState(null);

  useEffect(() => {
    const selectedProduct = data.products.find((prod) => prod.id === parseInt(id));
    setProduct(selectedProduct);
  }, [id]);

  if (!product) {
    return (
      <Container sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom>
          Product not found!
        </Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ mt: 10 }}>
      <ProductContainer>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <ProductImage image={product.image} title={product.name} />
          </Grid>
          <Grid item xs={12} md={6}>
            <CardContent>
              <Typography variant="h4" gutterBottom>
                {product.name}
              </Typography>
              <Typography variant="body1" color="textSecondary" gutterBottom>
                {product.details}
              </Typography>
              <Box my={2}>
                <Typography variant="h6">Features:</Typography>
                <ul>
                  {product.features.map((feature, index) => (
                    <li key={index}>
                      <Typography variant="body1">{feature}</Typography>
                    </li>
                  ))}
                </ul>
              </Box>
            </CardContent>
          </Grid>
        </Grid>
      </ProductContainer>
    </Container>
  );
};

export default ProductDetails;
